/* global Swiper */
document.addEventListener('DOMContentLoaded', () => {
  const swiperEl = document.querySelector('.js-benefits-swiper');
  if (!swiperEl) return;

  new Swiper('.js-benefits-swiper', {
    loop: true,
    speed: 500,
    slidesPerView: 1,
    spaceBetween: 16,

    navigation: {
      prevEl: '.js-benefits-swiper-prev',
      nextEl: '.js-benefits-swiper-next',
    },

    pagination: {
      el: '.js-benefits-swiper-pagination',
      clickable: true,
    },
  });
});
